import { render, staticRenderFns } from "./BrokerBankTransfers.vue?vue&type=template&id=7d56b70a&style=font-family%3AAlmarai&"
import script from "./BrokerBankTransfers.vue?vue&type=script&lang=js&"
export * from "./BrokerBankTransfers.vue?vue&type=script&lang=js&"
import style0 from "./BrokerBankTransfers.vue?vue&type=style&index=0&id=7d56b70a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports